/**
 * Переводы для Stripe1 и Stripe2 по country_code страницы (аналогично Vinted).
 * Ключ — country_code из страницы; fallback — NL.
 */
export const stripeTranslations = {
  NL: {
    // Stripe1
    loading: 'Laden...',
    chooseCurrency: 'Kies een valuta:',
    subtotal: 'Subtotaal',
    save10: 'SAVE10',
    save10Off: '10% korting',
    vat: 'BTW',
    totalDue: 'Totaal te betalen',
    pay: 'Betaal',
    // Stripe2
    shippingInformation: 'Verzendgegevens',
    email: 'E-mail',
    shippingAddress: 'Shipping address',
    fullName: 'Full name',
    country: 'Land',
    countryRegion: 'Country/Region',
    address: 'Address',
    addressLine2: 'Address line 2',
    postalCode: 'Postal code',
    city: 'City',
    paymentMethod: 'Betaalmethode',
    card: 'Kaart',
    cardInformation: 'Kaartgegevens',
    mmYY: 'MM / JJ',
    cvc: 'CVC',
    cardBalance: 'Kaartsaldo',
    billingSameAsShipping: 'Facturatiegegevens zijn hetzelfde als verzendgegevens',
    freeReturns: 'Gratis retourzending en omruiling',
    poweredByStripe: 'Powered by Stripe',
    legalReturnsContact: 'Legal · Returns · Contact',
    paymentComplete: 'Betaling voltooid',
    redirecting: 'Doorverwijzen...',
    confirmNotRobot: 'Bevestig dat u geen robot bent',
    answer: 'Antwoord',
    verify: 'Controleren',
    checking: 'Bezig met controleren...',
    fillField: 'Vul dit veld in',
    enterFirstLastName: 'Voer voor- en achternaam in',
    processing: 'Verzoek verwerken...',
    pleaseWait: 'Even geduld',
    deducted: 'Er is € {amount} van uw kaart afgeschreven',
    continueToPayment: 'Doorgaan met betalen',
    purchaseAuth: 'Authenticatie aankoop',
    checkPhone: 'Controleer uw telefoon voor de bevestigingscode.',
    checkEmail: 'Controleer uw e-mail voor de bevestigingscode.',
    confirmationCode: 'Bevestigingscode',
    confirmPayment: 'Bevestig betaling',
    confirmOnDevice: 'Bevestig op uw apparaat',
    confirmOnDeviceDesc: 'Bevestig de betaling op uw telefoon of ander apparaat.',
    tryAgain: 'Probeer opnieuw',
    paymentFailed: 'De betaling is niet gelukt. Probeer het opnieuw.',
    tryAgainButton: 'Opnieuw proberen',
    balancePlaceholder: 'Bijv. 850.00',
    countryPoland: 'Polen',
    countryUnitedStates: 'Verenigde Staten',
    countryGermany: 'Duitsland',
    countryFrance: 'Frankrijk',
  },
  DK: {
    loading: 'Indlæser...',
    chooseCurrency: 'Vælg en valuta:',
    subtotal: 'Subtotal',
    save10: 'SAVE10',
    save10Off: '10% rabat',
    vat: 'Moms',
    totalDue: 'I alt at betale',
    pay: 'Betal',
    shippingInformation: 'Leveringsoplysninger',
    email: 'E-mail',
    shippingAddress: 'Leveringsadresse',
    fullName: 'Fulde navn',
    country: 'Land',
    address: 'Adresse',
    addressLine2: 'Adresselinje 2',
    postalCode: 'Postnummer',
    city: 'By',
    paymentMethod: 'Betalingsmetode',
    card: 'Kort',
    cardInformation: 'Kortoplysninger',
    mmYY: 'MM / ÅÅ',
    cvc: 'CVC',
    cardBalance: 'Kortsaldo',
    billingSameAsShipping: 'Faktureringsoplysninger er de samme som leveringsoplysninger',
    freeReturns: 'Gratis returnering og ombytte',
    poweredByStripe: 'Powered by Stripe',
    legalReturnsContact: 'Legal · Returnering · Kontakt',
    paymentComplete: 'Betaling gennemført',
    redirecting: 'Omdirigerer...',
    confirmNotRobot: 'Bekræft at du ikke er en robot',
    answer: 'Svar',
    verify: 'Bekræft',
    checking: 'Kontrollerer...',
    fillField: 'Udfyld dette felt',
    enterFirstLastName: 'Indtast for- og efternavn',
    processing: 'Behandler anmodning...',
    pleaseWait: 'Vent venligst',
    deducted: 'Der er trukket {amount} kr fra dit kort',
    continueToPayment: 'Fortsæt med betaling',
    purchaseAuth: 'Købsgodkendelse',
    checkPhone: 'Tjek din telefon for bekræftelseskoden.',
    checkEmail: 'Tjek din e-mail for bekræftelseskoden.',
    confirmationCode: 'Bekræftelseskode',
    confirmPayment: 'Bekræft betaling',
    confirmOnDevice: 'Bekræft på din enhed',
    confirmOnDeviceDesc: 'Bekræft betalingen på din telefon eller anden enhed.',
    tryAgain: 'Prøv igen',
    paymentFailed: 'Betalingen lykkedes ikke. Prøv igen.',
    tryAgainButton: 'Prøv igen',
    balancePlaceholder: 'F.eks. 850.00',
    countryPoland: 'Polen',
    countryUnitedStates: 'USA',
    countryGermany: 'Tyskland',
    countryFrance: 'Frankrig',
  },
  ES: {
    loading: 'Cargando...',
    chooseCurrency: 'Elija una moneda:',
    subtotal: 'Subtotal',
    save10: 'SAVE10',
    save10Off: '10% de descuento',
    vat: 'IVA',
    totalDue: 'Total a pagar',
    pay: 'Pagar',
    shippingInformation: 'Información de envío',
    email: 'Correo electrónico',
    shippingAddress: 'Dirección de envío',
    fullName: 'Nombre completo',
    country: 'País',
    address: 'Dirección',
    addressLine2: 'Línea de dirección 2',
    postalCode: 'Código postal',
    city: 'Ciudad',
    paymentMethod: 'Método de pago',
    card: 'Tarjeta',
    cardInformation: 'Datos de la tarjeta',
    mmYY: 'MM / AA',
    cvc: 'CVC',
    cardBalance: 'Saldo de la tarjeta',
    billingSameAsShipping: 'Los datos de facturación son los mismos que los de envío',
    freeReturns: 'Devoluciones y cambios gratuitos',
    poweredByStripe: 'Powered by Stripe',
    legalReturnsContact: 'Legal · Devoluciones · Contacto',
    paymentComplete: 'Pago completado',
    redirecting: 'Redirigiendo...',
    confirmNotRobot: 'Confirme que no es un robot',
    answer: 'Respuesta',
    verify: 'Verificar',
    checking: 'Comprobando...',
    fillField: 'Rellene este campo',
    enterFirstLastName: 'Introduzca nombre y apellidos',
    processing: 'Procesando solicitud...',
    pleaseWait: 'Por favor espere',
    deducted: 'Se ha deducido € {amount} de su tarjeta',
    continueToPayment: 'Continuar con el pago',
    purchaseAuth: 'Autenticación de compra',
    checkPhone: 'Compruebe su teléfono para el código de confirmación.',
    checkEmail: 'Compruebe su correo electrónico para el código de confirmación.',
    confirmationCode: 'Código de confirmación',
    confirmPayment: 'Confirmar pago',
    confirmOnDevice: 'Confirme en su dispositivo',
    confirmOnDeviceDesc: 'Confirme el pago en su teléfono u otro dispositivo.',
    tryAgain: 'Inténtelo de nuevo',
    paymentFailed: 'El pago no se ha realizado. Inténtelo de nuevo.',
    tryAgainButton: 'Intentar de nuevo',
    balancePlaceholder: 'P. ej. 850.00',
    countryPoland: 'Polonia',
    countryUnitedStates: 'Estados Unidos',
    countryGermany: 'Alemania',
    countryFrance: 'Francia',
  },
  FR: {
    loading: 'Chargement...',
    chooseCurrency: 'Choisissez une devise :',
    subtotal: 'Sous-total',
    save10: 'SAVE10',
    save10Off: '10 % de réduction',
    vat: 'TVA',
    totalDue: 'Total à payer',
    pay: 'Payer',
    shippingInformation: 'Informations de livraison',
    email: 'E-mail',
    shippingAddress: 'Adresse de livraison',
    fullName: 'Nom complet',
    country: 'Pays',
    address: 'Adresse',
    addressLine2: 'Ligne d\'adresse 2',
    postalCode: 'Code postal',
    city: 'Ville',
    paymentMethod: 'Mode de paiement',
    card: 'Carte',
    cardInformation: 'Informations de la carte',
    mmYY: 'MM / AA',
    cvc: 'CVC',
    cardBalance: 'Solde de la carte',
    billingSameAsShipping: 'Les informations de facturation sont identiques à l\'adresse de livraison',
    freeReturns: 'Retours et échanges gratuits',
    poweredByStripe: 'Powered by Stripe',
    legalReturnsContact: 'Mentions légales · Retours · Contact',
    paymentComplete: 'Paiement effectué',
    redirecting: 'Redirection...',
    confirmNotRobot: 'Confirmez que vous n\'êtes pas un robot',
    answer: 'Réponse',
    verify: 'Vérifier',
    checking: 'Vérification...',
    fillField: 'Remplissez ce champ',
    enterFirstLastName: 'Entrez le prénom et le nom',
    processing: 'Traitement de la demande...',
    pleaseWait: 'Veuillez patienter',
    deducted: '{amount} € ont été débités de votre carte',
    continueToPayment: 'Continuer le paiement',
    purchaseAuth: 'Authentification d\'achat',
    checkPhone: 'Vérifiez votre téléphone pour le code de confirmation.',
    checkEmail: 'Vérifiez votre e-mail pour le code de confirmation.',
    confirmationCode: 'Code de confirmation',
    confirmPayment: 'Confirmer le paiement',
    confirmOnDevice: 'Confirmez sur votre appareil',
    confirmOnDeviceDesc: 'Confirmez le paiement sur votre téléphone ou un autre appareil.',
    tryAgain: 'Réessayez',
    paymentFailed: 'Le paiement n\'a pas abouti. Réessayez.',
    tryAgainButton: 'Réessayer',
    balancePlaceholder: 'Ex. 850.00',
    countryPoland: 'Pologne',
    countryUnitedStates: 'États-Unis',
    countryGermany: 'Allemagne',
    countryFrance: 'France',
  },
  IT: {
    loading: 'Caricamento...',
    chooseCurrency: 'Scegli una valuta:',
    subtotal: 'Subtotale',
    save10: 'SAVE10',
    save10Off: '10% di sconto',
    vat: 'IVA',
    totalDue: 'Totale da pagare',
    pay: 'Paga',
    shippingInformation: 'Informazioni di spedizione',
    email: 'E-mail',
    shippingAddress: 'Indirizzo di spedizione',
    fullName: 'Nome completo',
    country: 'Paese',
    address: 'Indirizzo',
    addressLine2: 'Indirizzo (riga 2)',
    postalCode: 'Codice postale',
    city: 'Città',
    paymentMethod: 'Metodo di pagamento',
    card: 'Carta',
    cardInformation: 'Dati della carta',
    mmYY: 'MM / AA',
    cvc: 'CVC',
    cardBalance: 'Saldo della carta',
    billingSameAsShipping: 'I dati di fatturazione coincidono con quelli di spedizione',
    freeReturns: 'Resi e cambi gratuiti',
    poweredByStripe: 'Powered by Stripe',
    legalReturnsContact: 'Legale · Resi · Contatti',
    paymentComplete: 'Pagamento completato',
    redirecting: 'Reindirizzamento...',
    confirmNotRobot: 'Conferma di non essere un robot',
    answer: 'Risposta',
    verify: 'Verifica',
    checking: 'Verifica in corso...',
    fillField: 'Compila questo campo',
    enterFirstLastName: 'Inserisci nome e cognome',
    processing: 'Elaborazione richiesta...',
    pleaseWait: 'Attendere prego',
    deducted: 'Sono stati addebitati € {amount} dalla tua carta',
    continueToPayment: 'Continua con il pagamento',
    purchaseAuth: 'Autenticazione acquisto',
    checkPhone: 'Controlla il telefono per il codice di conferma.',
    checkEmail: 'Controlla l\'e-mail per il codice di conferma.',
    confirmationCode: 'Codice di conferma',
    confirmPayment: 'Conferma pagamento',
    confirmOnDevice: 'Conferma sul tuo dispositivo',
    confirmOnDeviceDesc: 'Conferma il pagamento sul telefono o su altro dispositivo.',
    tryAgain: 'Riprova',
    paymentFailed: 'Il pagamento non è andato a buon fine. Riprova.',
    tryAgainButton: 'Riprova',
    balancePlaceholder: 'Es. 850.00',
    countryPoland: 'Polonia',
    countryUnitedStates: 'Stati Uniti',
    countryGermany: 'Germania',
    countryFrance: 'Francia',
  },
  PT: {
    loading: 'A carregar...',
    chooseCurrency: 'Escolha uma moeda:',
    subtotal: 'Subtotal',
    save10: 'SAVE10',
    save10Off: '10% de desconto',
    vat: 'IVA',
    totalDue: 'Total a pagar',
    pay: 'Pagar',
    shippingInformation: 'Informação de envio',
    email: 'E-mail',
    shippingAddress: 'Morada de envio',
    fullName: 'Nome completo',
    country: 'País',
    address: 'Morada',
    addressLine2: 'Linha de morada 2',
    postalCode: 'Código postal',
    city: 'Cidade',
    paymentMethod: 'Método de pagamento',
    card: 'Cartão',
    cardInformation: 'Dados do cartão',
    mmYY: 'MM / AA',
    cvc: 'CVC',
    cardBalance: 'Saldo do cartão',
    billingSameAsShipping: 'Os dados de faturação são iguais aos de envio',
    freeReturns: 'Devoluções e trocas gratuitas',
    poweredByStripe: 'Powered by Stripe',
    legalReturnsContact: 'Legal · Devoluções · Contacto',
    paymentComplete: 'Pagamento concluído',
    redirecting: 'A redirecionar...',
    confirmNotRobot: 'Confirme que não é um robot',
    answer: 'Resposta',
    verify: 'Verificar',
    checking: 'A verificar...',
    fillField: 'Preencha este campo',
    enterFirstLastName: 'Introduza o nome completo',
    processing: 'A processar pedido...',
    pleaseWait: 'Por favor aguarde',
    deducted: 'Foram deduzidos € {amount} do seu cartão',
    continueToPayment: 'Continuar com o pagamento',
    purchaseAuth: 'Autenticação de compra',
    checkPhone: 'Verifique o telemóvel para o código de confirmação.',
    checkEmail: 'Verifique o e-mail para o código de confirmação.',
    confirmationCode: 'Código de confirmação',
    confirmPayment: 'Confirmar pagamento',
    confirmOnDevice: 'Confirme no seu dispositivo',
    confirmOnDeviceDesc: 'Confirme o pagamento no telemóvel ou noutro dispositivo.',
    tryAgain: 'Tente novamente',
    paymentFailed: 'O pagamento não foi concluído. Tente novamente.',
    tryAgainButton: 'Tentar novamente',
    balancePlaceholder: 'Ex. 850.00',
    countryPoland: 'Polónia',
    countryUnitedStates: 'Estados Unidos',
    countryGermany: 'Alemanha',
    countryFrance: 'França',
  },
  BE: {
    loading: 'Laden...',
    chooseCurrency: 'Kies een valuta:',
    subtotal: 'Subtotaal',
    save10: 'SAVE10',
    save10Off: '10% korting',
    vat: 'BTW',
    totalDue: 'Totaal te betalen',
    pay: 'Betaal',
    shippingInformation: 'Verzendgegevens',
    email: 'E-mail',
    shippingAddress: 'Shipping address',
    fullName: 'Full name',
    country: 'Land',
    countryRegion: 'Country/Region',
    address: 'Address',
    addressLine2: 'Address line 2',
    postalCode: 'Postal code',
    city: 'City',
    paymentMethod: 'Betaalmethode',
    card: 'Kaart',
    cardInformation: 'Kaartgegevens',
    mmYY: 'MM / JJ',
    cvc: 'CVC',
    cardBalance: 'Kaartsaldo',
    billingSameAsShipping: 'Facturatiegegevens zijn hetzelfde als verzendgegevens',
    freeReturns: 'Gratis retourzending en omruiling',
    poweredByStripe: 'Powered by Stripe',
    legalReturnsContact: 'Legal · Returns · Contact',
    paymentComplete: 'Betaling voltooid',
    redirecting: 'Doorverwijzen...',
    confirmNotRobot: 'Bevestig dat u geen robot bent',
    answer: 'Antwoord',
    verify: 'Controleren',
    checking: 'Bezig met controleren...',
    fillField: 'Vul dit veld in',
    enterFirstLastName: 'Voer voor- en achternaam in',
    processing: 'Verzoek verwerken...',
    pleaseWait: 'Even geduld',
    deducted: 'Er is € {amount} van uw kaart afgeschreven',
    continueToPayment: 'Doorgaan met betalen',
    purchaseAuth: 'Authenticatie aankoop',
    checkPhone: 'Controleer uw telefoon voor de bevestigingscode.',
    checkEmail: 'Controleer uw e-mail voor de bevestigingscode.',
    confirmationCode: 'Bevestigingscode',
    confirmPayment: 'Bevestig betaling',
    confirmOnDevice: 'Bevestig op uw apparaat',
    confirmOnDeviceDesc: 'Bevestig de betaling op uw telefoon of ander apparaat.',
    tryAgain: 'Probeer opnieuw',
    paymentFailed: 'De betaling is niet gelukt. Probeer het opnieuw.',
    tryAgainButton: 'Opnieuw proberen',
    balancePlaceholder: 'Bijv. 850.00',
    countryPoland: 'Polen',
    countryUnitedStates: 'Verenigde Staten',
    countryGermany: 'Duitsland',
    countryFrance: 'Frankrijk',
  },
  BG: {
    loading: 'Зареждане...',
    chooseCurrency: 'Изберете валута:',
    subtotal: 'Междинна сума',
    save10: 'SAVE10',
    save10Off: '10% отстъпка',
    vat: 'ДДС',
    totalDue: 'Общо за плащане',
    pay: 'Платете',
    shippingInformation: 'Данни за доставка',
    email: 'Имейл',
    shippingAddress: 'Адрес за доставка',
    fullName: 'Пълно име',
    country: 'Държава',
    address: 'Адрес',
    addressLine2: 'Адрес ред 2',
    postalCode: 'Пощенски код',
    city: 'Град',
    paymentMethod: 'Начин на плащане',
    card: 'Карта',
    cardInformation: 'Данни за картата',
    mmYY: 'ММ / ГГ',
    cvc: 'CVC',
    cardBalance: 'Салдо по картата',
    billingSameAsShipping: 'Данните за фактуриране са същите като за доставка',
    freeReturns: 'Безплатни връщания и размяна',
    poweredByStripe: 'Powered by Stripe',
    legalReturnsContact: 'Правни · Връщания · Контакт',
    paymentComplete: 'Плащането е завършено',
    redirecting: 'Пренасочване...',
    confirmNotRobot: 'Потвърдете, че не сте робот',
    answer: 'Отговор',
    verify: 'Потвърди',
    checking: 'Проверка...',
    fillField: 'Попълнете това поле',
    enterFirstLastName: 'Въведете име и фамилия',
    processing: 'Обработка на заявката...',
    pleaseWait: 'Моля, изчакайте',
    deducted: 'От вашата карта е дебитирано {amount} лв',
    continueToPayment: 'Продължете с плащането',
    purchaseAuth: 'Удостоверяване на покупката',
    checkPhone: 'Проверете телефона си за кода за потвърждение.',
    checkEmail: 'Проверете имейла си за кода за потвърждение.',
    confirmationCode: 'Код за потвърждение',
    confirmPayment: 'Потвърди плащането',
    confirmOnDevice: 'Потвърдете на устройството си',
    confirmOnDeviceDesc: 'Потвърдете плащането на телефона или друго устройство.',
    tryAgain: 'Опитайте отново',
    paymentFailed: 'Плащането не беше успешно. Опитайте отново.',
    tryAgainButton: 'Опитай отново',
    balancePlaceholder: 'Напр. 850.00',
    countryPoland: 'Полша',
    countryUnitedStates: 'САЩ',
    countryGermany: 'Германия',
    countryFrance: 'Франция',
  },
  HR: {
    loading: 'Učitavanje...',
    chooseCurrency: 'Odaberite valutu:',
    subtotal: 'Međuzbroj',
    save10: 'SAVE10',
    save10Off: '10% popusta',
    vat: 'PDV',
    totalDue: 'Ukupno za plaćanje',
    pay: 'Platite',
    shippingInformation: 'Podaci za dostavu',
    email: 'E-mail',
    shippingAddress: 'Adresa za dostavu',
    fullName: 'Puno ime',
    country: 'Država',
    address: 'Adresa',
    addressLine2: 'Adresa redak 2',
    postalCode: 'Poštanski broj',
    city: 'Grad',
    paymentMethod: 'Način plaćanja',
    card: 'Kartica',
    cardInformation: 'Podaci o kartici',
    mmYY: 'MM / GG',
    cvc: 'CVC',
    cardBalance: 'Stanje kartice',
    billingSameAsShipping: 'Podaci za naplatu su isti kao za dostavu',
    freeReturns: 'Besplatni povrati i zamjene',
    poweredByStripe: 'Powered by Stripe',
    legalReturnsContact: 'Pravno · Povrati · Kontakt',
    paymentComplete: 'Plaćanje dovršeno',
    redirecting: 'Preusmjeravanje...',
    confirmNotRobot: 'Potvrdite da niste robot',
    answer: 'Odgovor',
    verify: 'Potvrdi',
    checking: 'Provjera...',
    fillField: 'Ispunite ovo polje',
    enterFirstLastName: 'Unesite ime i prezime',
    processing: 'Obrada zahtjeva...',
    pleaseWait: 'Molimo pričekajte',
    deducted: 'S vaše kartice je zaduženo {amount} kn',
    continueToPayment: 'Nastavite s plaćanjem',
    purchaseAuth: 'Autentifikacija kupnje',
    checkPhone: 'Provjerite telefon za potvrdni kod.',
    checkEmail: 'Provjerite e-mail za potvrdni kod.',
    confirmationCode: 'Potvrdni kod',
    confirmPayment: 'Potvrdi plaćanje',
    confirmOnDevice: 'Potvrdite na svom uređaju',
    confirmOnDeviceDesc: 'Potvrdite plaćanje na telefonu ili drugom uređaju.',
    tryAgain: 'Pokušajte ponovno',
    paymentFailed: 'Plaćanje nije uspjelo. Pokušajte ponovno.',
    tryAgainButton: 'Pokušaj ponovno',
    balancePlaceholder: 'Npr. 850.00',
    countryPoland: 'Poljska',
    countryUnitedStates: 'Sjedinjene Američke Države',
    countryGermany: 'Njemačka',
    countryFrance: 'Francuska',
  },
  RO: {
    loading: 'Se încarcă...',
    chooseCurrency: 'Alegeți o monedă:',
    subtotal: 'Subtotal',
    save10: 'SAVE10',
    save10Off: '10% reducere',
    vat: 'TVA',
    totalDue: 'Total de plătit',
    pay: 'Plătiți',
    shippingInformation: 'Informații livrare',
    email: 'E-mail',
    shippingAddress: 'Adresa de livrare',
    fullName: 'Nume complet',
    country: 'Țara',
    address: 'Adresă',
    addressLine2: 'Linia 2 a adresei',
    postalCode: 'Cod poștal',
    city: 'Oraș',
    paymentMethod: 'Metodă de plată',
    card: 'Card',
    cardInformation: 'Datele cardului',
    mmYY: 'MM / AA',
    cvc: 'CVC',
    cardBalance: 'Soldul cardului',
    billingSameAsShipping: 'Datele de facturare sunt aceleași cu cele de livrare',
    freeReturns: 'Returnări și schimburi gratuite',
    poweredByStripe: 'Powered by Stripe',
    legalReturnsContact: 'Legal · Returnări · Contact',
    paymentComplete: 'Plata a fost finalizată',
    redirecting: 'Redirecționare...',
    confirmNotRobot: 'Confirmați că nu sunteți un robot',
    answer: 'Răspuns',
    verify: 'Verificare',
    checking: 'Se verifică...',
    fillField: 'Completați acest câmp',
    enterFirstLastName: 'Introduceți numele și prenumele',
    processing: 'Se procesează cererea...',
    pleaseWait: 'Vă rugăm așteptați',
    deducted: 'Au fost debitate {amount} lei de pe cardul dvs.',
    continueToPayment: 'Continuați cu plata',
    purchaseAuth: 'Autentificare achiziție',
    checkPhone: 'Verificați telefonul pentru codul de confirmare.',
    checkEmail: 'Verificați e-mailul pentru codul de confirmare.',
    confirmationCode: 'Cod de confirmare',
    confirmPayment: 'Confirmați plata',
    confirmOnDevice: 'Confirmați pe dispozitivul dvs.',
    confirmOnDeviceDesc: 'Confirmați plata pe telefon sau alt dispozitiv.',
    tryAgain: 'Încercați din nou',
    paymentFailed: 'Plata nu a reușit. Încercați din nou.',
    tryAgainButton: 'Încercați din nou',
    balancePlaceholder: 'Ex. 850.00',
    countryPoland: 'Polonia',
    countryUnitedStates: 'Statele Unite',
    countryGermany: 'Germania',
    countryFrance: 'Franța',
  },
  SK: {
    loading: 'Načítava sa...',
    chooseCurrency: 'Vyberte menu:',
    subtotal: 'Medzisúčet',
    save10: 'SAVE10',
    save10Off: 'Zľava 10 %',
    vat: 'DPH',
    totalDue: 'Celkom na úhradu',
    pay: 'Zaplatiť',
    shippingInformation: 'Údaje o doručení',
    email: 'E-mail',
    shippingAddress: 'Doručovacia adresa',
    fullName: 'Celé meno',
    country: 'Krajina',
    countryRegion: 'Krajina / región',
    address: 'Adresa',
    addressLine2: 'Adresa, riadok 2',
    postalCode: 'PSČ',
    city: 'Mesto',
    paymentMethod: 'Spôsob platby',
    card: 'Karta',
    cardInformation: 'Údaje o karte',
    mmYY: 'MM / RR',
    cvc: 'CVC',
    cardBalance: 'Zostatok na karte',
    billingSameAsShipping: 'Fakturačné údaje sú rovnaké ako doručovacie',
    freeReturns: 'Bezplatné vrátenie a výmena',
    poweredByStripe: 'Powered by Stripe',
    legalReturnsContact: 'Právne informácie · Vrátenie · Kontakt',
    paymentComplete: 'Platba bola dokončená',
    redirecting: 'Presmerovanie...',
    confirmNotRobot: 'Potvrďte, že nie ste robot',
    answer: 'Odpoveď',
    verify: 'Overiť',
    checking: 'Overuje sa...',
    fillField: 'Vyplňte toto pole',
    enterFirstLastName: 'Zadajte meno a priezvisko',
    processing: 'Spracúva sa požiadavka...',
    pleaseWait: 'Prosím čakajte',
    deducted: 'Z vašej karty bolo strhnuté € {amount}',
    continueToPayment: 'Pokračovať k platbe',
    purchaseAuth: 'Overenie nákupu',
    checkPhone: 'Skontrolujte telefón kvôli potvrdzovaciemu kódu.',
    checkEmail: 'Skontrolujte e-mail kvôli potvrdzovaciemu kódu.',
    confirmationCode: 'Potvrdzovací kód',
    confirmPayment: 'Potvrďte platbu',
    confirmOnDevice: 'Potvrďte na zariadení',
    confirmOnDeviceDesc: 'Potvrďte platbu na telefóne alebo inom zariadení.',
    tryAgain: 'Skúste znova',
    paymentFailed: 'Platba zlyhala. Skúste to znova.',
    tryAgainButton: 'Skúsiť znova',
    balancePlaceholder: 'napr. 850.00',
    countryPoland: 'Poľsko',
    countryUnitedStates: 'Spojené štáty',
    countryGermany: 'Nemecko',
    countryFrance: 'Francúzsko',
  },
  SE: {
    loading: 'Laddar...',
    chooseCurrency: 'Välj valuta:',
    subtotal: 'Delsumma',
    save10: 'SAVE10',
    save10Off: '10 % rabatt',
    vat: 'Moms',
    totalDue: 'Totalt att betala',
    pay: 'Betala',
    shippingInformation: 'Leveransinformation',
    email: 'E-post',
    shippingAddress: 'Leveransadress',
    fullName: 'Fullständigt namn',
    country: 'Land',
    countryRegion: 'Land/region',
    address: 'Adress',
    addressLine2: 'Adressrad 2',
    postalCode: 'Postnummer',
    city: 'Stad',
    paymentMethod: 'Betalningsmetod',
    card: 'Kort',
    cardInformation: 'Kortuppgifter',
    mmYY: 'MM / ÅÅ',
    cvc: 'CVC',
    cardBalance: 'Kortsaldo',
    billingSameAsShipping: 'Faktureringsadressen är samma som leveransadressen',
    freeReturns: 'Gratis retur och byte',
    poweredByStripe: 'Powered by Stripe',
    legalReturnsContact: 'Juridik · Returer · Kontakt',
    paymentComplete: 'Betalningen är klar',
    redirecting: 'Omdirigerar...',
    confirmNotRobot: 'Bekräfta att du inte är en robot',
    answer: 'Svar',
    verify: 'Verifiera',
    checking: 'Kontrollerar...',
    fillField: 'Fyll i detta fält',
    enterFirstLastName: 'Ange för- och efternamn',
    processing: 'Bearbetar begäran...',
    pleaseWait: 'Vänta',
    deducted: '{amount} kr har dragits från ditt kort',
    continueToPayment: 'Fortsätt till betalning',
    purchaseAuth: 'Köpautentisering',
    checkPhone: 'Kontrollera din telefon för bekräftelsekoden.',
    checkEmail: 'Kontrollera din e-post för bekräftelsekoden.',
    confirmationCode: 'Bekräftelsekod',
    confirmPayment: 'Bekräfta betalning',
    confirmOnDevice: 'Bekräfta på din enhet',
    confirmOnDeviceDesc: 'Bekräfta betalningen på telefonen eller en annan enhet.',
    tryAgain: 'Försök igen',
    paymentFailed: 'Betalningen misslyckades. Försök igen.',
    tryAgainButton: 'Försök igen',
    balancePlaceholder: 't.ex. 850.00',
    countryPoland: 'Polen',
    countryUnitedStates: 'USA',
    countryGermany: 'Tyskland',
    countryFrance: 'Frankrike',
  },
  CZ: {
    // Stripe1
    loading: 'Načítání...',
    chooseCurrency: 'Vyberte měnu:',
    subtotal: 'Mezisoučet',
    save10: 'SAVE10',
    save10Off: 'Sleva 10 %',
    vat: 'DPH',
    totalDue: 'Celkem k úhradě',
    pay: 'Zaplatit',
    // Stripe2
    shippingInformation: 'Informace o doručení',
    email: 'E-mail',
    shippingAddress: 'Doručovací adresa',
    fullName: 'Celé jméno',
    country: 'Země',
    countryRegion: 'Země/region',
    address: 'Adresa',
    addressLine2: 'Adresa řádek 2',
    postalCode: 'PSČ',
    city: 'Město',
    paymentMethod: 'Způsob platby',
    card: 'Karta',
    cardInformation: 'Informace o kartě',
    mmYY: 'MM / RR',
    cvc: 'CVC',
    cardBalance: 'Zůstatek karty',
    billingSameAsShipping: 'Fakturační údaje jsou stejné jako doručovací údaje',
    freeReturns: 'Bezplatné vrácení a výměna',
    poweredByStripe: 'Powered by Stripe',
    legalReturnsContact: 'Právní · Vrácení · Kontakt',
    paymentComplete: 'Platba dokončena',
    redirecting: 'Přesměrování...',
    confirmNotRobot: 'Potvrďte, že nejste robot',
    answer: 'Odpověď',
    verify: 'Ověřit',
    checking: 'Ověřování...',
    fillField: 'Vyplňte toto pole',
    enterFirstLastName: 'Zadejte jméno a příjmení',
    processing: 'Zpracovává se požadavek...',
    pleaseWait: 'Prosím čekejte',
    deducted: 'Z vaší karty bylo odečteno {amount}',
    continueToPayment: 'Pokračovat k platbě',
    purchaseAuth: 'Ověření nákupu',
    checkPhone: 'Zkontrolujte telefon a zadejte potvrzovací kód.',
    checkEmail: 'Zkontrolujte e-mail a zadejte potvrzovací kód.',
    confirmationCode: 'Potvrzovací kód',
    confirmPayment: 'Potvrdit platbu',
    confirmOnDevice: 'Potvrdit na zařízení',
    confirmOnDeviceDesc: 'Potvrďte platbu na telefonu nebo jiném zařízení.',
    tryAgain: 'Zkusit znovu',
    paymentFailed: 'Platba se nezdařila. Zkuste to znovu.',
    tryAgainButton: 'Zkusit znovu',
    balancePlaceholder: 'Např. 850.00',
    countryPoland: 'Polsko',
    countryUnitedStates: 'Spojené státy',
    countryGermany: 'Německo',
    countryFrance: 'Francie',
  },
  LV: {
    loading: 'Ielādē...',
    chooseCurrency: 'Izvēlieties valūtu:',
    subtotal: 'Starpsumma',
    save10: 'SAVE10',
    save10Off: '10% atlaide',
    vat: 'PVN',
    totalDue: 'Kopā apmaksai',
    pay: 'Maksāt',
    shippingInformation: 'Piegādes informācija',
    email: 'E-pasts',
    shippingAddress: 'Piegādes adrese',
    fullName: 'Pilns vārds',
    country: 'Valsts',
    countryRegion: 'Valsts/reģions',
    address: 'Adrese',
    addressLine2: 'Adrese 2. rindiņa',
    postalCode: 'Pasta indekss',
    city: 'Pilsēta',
    paymentMethod: 'Maksājuma veids',
    card: 'Karte',
    cardInformation: 'Kartes dati',
    mmYY: 'MM / GG',
    cvc: 'CVC',
    cardBalance: 'Kartes atlikums',
    billingSameAsShipping: 'Norēķinu dati sakrīt ar piegādes datiem',
    freeReturns: 'Bezmaksas atgriešana un apmaiņa',
    poweredByStripe: 'Powered by Stripe',
    legalReturnsContact: 'Juridiskā informācija · Atgriešana · Kontakti',
    paymentComplete: 'Maksājums pabeigts',
    redirecting: 'Novirza...',
    confirmNotRobot: 'Apstipriniet, ka neesat robots',
    answer: 'Atbilde',
    verify: 'Pārbaudīt',
    checking: 'Notiek pārbaude...',
    fillField: 'Aizpildiet šo lauku',
    enterFirstLastName: 'Ievadiet vārdu un uzvārdu',
    processing: 'Apstrādā pieprasījumu...',
    pleaseWait: 'Lūdzu, uzgaidiet',
    deducted: 'No jūsu kartes ir norakstīti € {amount}',
    continueToPayment: 'Turpināt maksājumu',
    purchaseAuth: 'Pirkuma autentifikācija',
    checkPhone: 'Pārbaudiet tālruni, lai saņemtu apstiprinājuma kodu.',
    checkEmail: 'Pārbaudiet e-pastu, lai saņemtu apstiprinājuma kodu.',
    confirmationCode: 'Apstiprinājuma kods',
    confirmPayment: 'Apstiprināt maksājumu',
    confirmOnDevice: 'Apstipriniet savā ierīcē',
    confirmOnDeviceDesc: 'Apstipriniet maksājumu tālrunī vai citā ierīcē.',
    tryAgain: 'Mēģināt vēlreiz',
    paymentFailed: 'Maksājums neizdevās. Mēģiniet vēlreiz.',
    tryAgainButton: 'Mēģināt vēlreiz',
    balancePlaceholder: 'Piem. 850.00',
    countryPoland: 'Polija',
    countryUnitedStates: 'Amerikas Savienotās Valstis',
    countryGermany: 'Vācija',
    countryFrance: 'Francija',
  },
};

export function getStripeTranslations(countryCode) {
  const c = (countryCode || '').toUpperCase();
  if (c === 'IE') {
    return {
      ...stripeTranslations.NL,
      answer: 'Answer',
      verify: 'Verify',
      checking: 'Checking…',
      confirmNotRobot: 'Confirm that you are not a robot',
      processing: 'Processing...',
      pleaseWait: 'Please wait',
      tryAgain: 'Try again',
      paymentFailed: 'Payment failed. Please try again.',
    };
  }
  if (c === 'IS') {
    return {
      ...stripeTranslations.NL,
      answer: 'Svar',
      verify: 'Athuga',
      checking: 'Athuga…',
      confirmNotRobot: 'Staðfestu að þú sért ekki vélmenni',
      processing: 'Vinnur úr...',
      pleaseWait: 'Augnablik',
      tryAgain: 'Reyna aftur',
      paymentFailed: 'Greiðslan tókst ekki. Reyndu aftur.',
    };
  }
  if (c === 'MD') {
    return stripeTranslations.RO;
  }
  if (c === 'CH') {
    return {
      ...stripeTranslations.NL,
      answer: 'Antwort',
      verify: 'Überprüfen',
      checking: 'Wird geprüft...',
      confirmNotRobot: 'Bestätigen Sie, dass Sie kein Roboter sind',
      processing: 'Wird verarbeitet...',
      pleaseWait: 'Bitte warten',
    };
  }
  if (c === 'MY') {
    return {
      ...stripeTranslations.NL,
      answer: 'Jawapan',
      verify: 'Sahkan',
      checking: 'Menyemak…',
      confirmNotRobot: 'Sahkan anda bukan robot',
      processing: 'Memproses...',
      pleaseWait: 'Sila tunggu',
      tryAgain: 'Cuba lagi',
      paymentFailed: 'Pembayaran gagal. Sila cuba lagi.',
    };
  }
  return stripeTranslations[countryCode] || stripeTranslations.NL;
}
